export default function adjustLetterSpacing(element) {
  const fs = Number.parseInt(getComputedStyle(element.node).fontSize.replace('px'), 10)
  
  if (element.attr('si:base-ls') === null && element.node.style.letterSpacing == '') {
    const ls = Number.parseInt(getComputedStyle(element.node).letterSpacing.replace('px'), 10)
    if(ls > -10000 && ls < 10000){
    //console.log("ls ok");
    
    const calc = Math.round((ls*1000)/fs);
    element.attr('si:base-ls', calc)
    //console.log(calc); 
    element.node.style.letterSpacing = `${parseInt(element.attr('si:base-ls'))/1000}em`
    }
  }
}